import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import BankAccountAddForm from "../../components/BankAccount/Add/BankAccountAddForm";
import { withRouter } from "react-router";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { QUERY_BANK_ACCOUNT } from "../../service/ApolloClient/ApolloQueries";
import BankAccountListAttachment from "./BankAccountListAttachment";

export const BANK_ACCOUNT_SELECT_EDIT = "BANK_ACCOUNT_SELECT_EDIT";
export const CAR_CONTRACT_SELECT_ATTACHMENT = "CAR_CONTRACT_SELECT_ATTACHMENT";

class BankAccountEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: BANK_ACCOUNT_SELECT_EDIT,
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage() {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_BANK_ACCOUNT,
        variables: {
          id: parseInt(this.state.id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = res.data.bankAccount;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  }

  handleSelectPage(page) {
    this.setState({
      pageSelect: page,
    });
  }

  render() {
    const { loading, data, pageSelect } = this.state;

    let componentSelect = <Wrapper>در حال بارگزاری</Wrapper>;

    if (pageSelect === BANK_ACCOUNT_SELECT_EDIT) {
      componentSelect = (
        <BankAccountAddForm
          handleSelectPage={this.handleSelectPage}
          data={data}
          isEdit={true}
        />
      );
    } else if (pageSelect === CAR_CONTRACT_SELECT_ATTACHMENT) {
      componentSelect = (
        <BankAccountListAttachment
          carContract={data}
          handleBack={() => {
            this.handleSelectPage(BANK_ACCOUNT_SELECT_EDIT);
          }}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش حساب بانکی ",
              to: "/bank-account/edit",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Wrapper>در حال بارگزاری</Wrapper>
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(BankAccountEditPage);
